import { ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnInit, Output, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router, ActivatedRoute } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';
import { parseJSON } from 'jquery';
import { DomSanitizer } from '@angular/platform-browser';

declare let window;

@Component({
  selector: 'withdraw-result.component',
  templateUrl: '../sharedTemplates/withdraw-result.component.html',
})
export class WithdrawResultComponent {
  coinbaseDatas: UntypedFormGroup;
  coinbaseDataRaw: any;
  firststep = true;
  statu = '0';
  constructor(
    private _changeDetection: ChangeDetectorRef,
    private _FormBuilder: UntypedFormBuilder,
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _router: Router,
    private _DataHelper: DataHelper,
    private domSanitizer: DomSanitizer,
    private route: ActivatedRoute
  ) {
    this.coinbaseDatas = _FormBuilder.group({
      amount: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(5), Validators.max(10000)]),
    });
  }

  ngAfterViewInit() {
    this._UiHelper.setNavbarTitle('CreditCard', true);

    this.route.params.subscribe(params => {
      //orderid/:ordercode/:goapihash
      this.statu = params['statu'];

      if (this.statu != '0') {
        if (window.self !== window.top) {
          // checking if it is an iframe
          window.parent.location.href = '/withdrawresult/' + this.statu;
        } else {
          if (this._UserHelper.customerUser.CustomerId) {
            this._ApiService.getClient().then().catch();
          }
          if (this.statu == '1') {
            //window.gtag('event', 'conversion', { 'send_to': 'AW-440849578/XNpmCIXVtfEBEKqpm9IB', 'transaction_id': '' });
          }
        }
      }
    });

    //if (window.self !== window.top) { // checking if it is an iframe
    //  window.parent.location.href = "/home";
    //} else {
    //  window.location.href = "/home";
    //}
  }
}
